import React, { useState, useEffect } from "react";
import random from "../../assets/random_pp.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Profile.module.css";

import {
  getProfileDetails,
  userProfileUpdate,
} from "../../redux/actions/userActions";

const Profile = ({ history }) => {
  const dispatch = useDispatch();

  //   const userLogin = useSelector((state) => state.userLogin);
  //   const { userInfo } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);
  const { user: userInfo } = userDetails;

  const profileUpdate = useSelector((state) => state.profileUpdate);
  const { loading, update, error } = profileUpdate;

  useEffect(() => {
    if (userInfo && !userInfo) {
      history.push("/login");
    }

    dispatch(getProfileDetails());
  }, [update, userInfo]);

  const detail = userInfo && userInfo;

  const [name, setName] = useState(detail && userInfo.name);
  const [email, setEmail] = useState(detail && userInfo.email);
  const [phone, setPhone] = useState(detail && userInfo.phone);

  const form = {
    email,
    phone,
    name,
  };

  const submitHandler = () => {
    dispatch(userProfileUpdate(form));
    setEmail(detail && detail.email);
    setName(detail && detail.name);
    setPhone(detail && detail.phone);
  };
  console.log(detail);
  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <div className={styles.topHeader}>
          <Link to="/my-account">
            <i className={styles.backIcon + " fas fa-chevron-left"}></i>
          </Link>
          <h1>My Profile</h1>
        </div>
        <div className={styles.profile}>
          <img src={random} alt="random-pic" />
        </div>
      </header>

      <main>
        <div className={styles.row}>
          <h2>Full Name</h2>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className={styles.row}>
          <h2>Email Address</h2>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className={styles.row}>
          <h2>Phone Number</h2>
          <input
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div>
          <button onClick={submitHandler}>
            {loading ? <span>Loading...</span> : <span>Update</span>}
          </button>
          {error && alert(error)}
        </div>
      </main>
    </div>
  );
};

export default Profile;
